import type { Module } from '@/types/modules.interfaces'

const blacklist: string[] = [
  'smb_edition',
  'psxlegalassistant',
  'ps_helpcenter',
]

const authoriseModule = (module: Module) => !blacklist.includes(module.name)

export { blacklist, authoriseModule }
